import { luuDonVi, xoaDonVi } from '@app/services/donvi';
import { ContentHeader } from '@components';
import { Select } from 'antd';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import { Loader } from 'react-clip-loader';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { layChiTietDonVi } from '../../services/donvi';
import DonViSelectTree from '../utils/DonViSelectTree';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

export const ChiTietDonVi = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [openModalXoa, setOpenModalXoa] = useState(false);
    const [title, setTitle] = useState("Thêm mới đơn vị");
    const menu: any = menuHelper.checkMultiPermission([Links.DonVi.Xoa]);
    const [themMoi, setThemMoi] = useState(true);
    const dispatch = useDispatch();
    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            "id": 0,
            "ma": "",
            "ten": "",
            "diaChi": "",
            "dienThoai": "",
            thuTu: 0,
            "maSoThue": "",
            "email": "",
            "fax": "",
            "website": "",
            "tenNguoiDaiDien": "",
            "idDVCha": 0,
            "trangThai": 1
        },
        validationSchema: Yup.object({
            ma: Yup.string().required('Bắt buộc'),
            ten: Yup.string().required('Bắt buộc'),
            email: Yup.string().required('Bắt buộc').email('Email không đúng định dạng'),
            thuTu: Yup.number().required('Bắt buộc').min(0, 'Thứ tự tối thiểu bằng 0')
        }),
        onSubmit: (values) => {
            submitLuu(values);
        }
    });
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = params.get('id') || '';
        setLoading(true);
        if (parseInt(id) > 0) {
            layChiTiet(parseInt(id))
                .then((data: any) => {
                    if (data?.id > 0) {
                        setFieldValue("id", data?.id || 0);
                        setFieldValue("idDVCha", data?.idDVCha || 0);
                        setFieldValue("trangThai", data?.trangThai || 0);
                        setFieldValue("ma", data?.ma || "");
                        setFieldValue("ten", data?.ten || "");
                        setFieldValue("diaChi", data?.diaChi || "");
                        setFieldValue("dienThoai", data?.dienThoai || "");
                        setFieldValue("thuTu", data?.thuTu || 0);
                        setFieldValue("maSoThue", data?.maSoThue || "");
                        setFieldValue("email", data?.email || "");
                        setFieldValue("fax", data?.fax || "");
                        setFieldValue("website", data?.website || "");
                        setFieldValue("tenNguoiDaiDien", data?.tenNguoiDaiDien || "");
                        setThemMoi(false);
                        setTitle("Chi tiết đơn vị");
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                });
        }
        setLoading(false);
    }, []);
    const layChiTiet = async (id: number) => {
        try {
            return await layChiTietDonVi(id);
        } catch (error: any) {
            navigate(Links.DonVi.DanhSach);
            toast.error("Đơn vị không tồn tại hoặc không có quyền xem!");
        }
    };

    const onChange = (e: any) => {
        var { name, value } = e.target;
        setFieldValue(name, value);
    };
    const submitLuu = async (value: any) => {
        try {
            dispatch(showLoadingScreen());
            await luuDonVi(value);
            dispatch(hideLoadingScreen());
            setErrors({});
            setTouched({});
            toast.success("Lưu thành công!");
            if (value.id == 0) {
                navigate(Links.DonVi.DanhSach);
            }
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            setErrors({});
            setTouched({});
            toast.error(error.message || "Vui lòng thử lại");
        };
    }

    const xoa = async () => {
        try {
            dispatch(showLoadingScreen());
            let temp = await xoaDonVi(values.id);
            dispatch(hideLoadingScreen());
            setOpenModalXoa(false);
            if (temp) {
                toast.success('Xóa đơn vị thành công');
                navigate(Links.DonVi.DanhSach);
            } else {
                toast.error('Xóa đơn vị không thành công! Vui lòng thử lại.');
            }
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error('Xóa đơn vị không thành công! Vui lòng thử lại.');
        };
    };

    if (loading) {
        return (
            <Loader small={true} color={'#2d4059'} secondaryColor={'#e5e5e5'} />
        );
    }
    return (
        <>
            <Modal show={openModalXoa} onHide={() => setOpenModalXoa(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Xóa đơn vị</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Bạn có muốn xóa đơn vị <strong>{values.ten}</strong> không?
                    <br />
                    <strong><span className="text-red">Lưu ý:</span></strong> Sẽ xóa các đơn vị con và người dùng liên quan.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalXoa(false)}>
                        Đóng
                    </Button>
                    <Button variant="danger" className="btn-sm" onClick={() => xoa()}>
                        Xóa
                    </Button>
                </Modal.Footer>
            </Modal>
            <ContentHeader title={title} />
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Mã đơn vị: <span className="text-red"> * </span>
                                    </label>
                                    <div className="col-sm-4">
                                        <Form.Control
                                            id="ma"
                                            name="ma"
                                            type="text"
                                            placeholder="Mã đơn vị"
                                            onChange={handleChange}
                                            value={values.ma}
                                            isValid={touched.ma && !errors.ma}
                                            isInvalid={touched.ma && !!errors.ma}
                                        />
                                        {touched.ma && errors.ma ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.ma}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                    <label className="col-sm-2 col-form-label">Tên đơn vị: <span className="text-red"> * </span>
                                    </label>
                                    <div className="col-sm-4">
                                        <Form.Control
                                            id="ten"
                                            name="ten"
                                            type="text"
                                            placeholder="Tên đơn vị"
                                            onChange={handleChange}
                                            value={values.ten}
                                            isValid={touched.ten && !errors.ten}
                                            isInvalid={touched.ten && !!errors.ten}
                                        />
                                        {touched.ten && errors.ten ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.ten}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <label className="col-sm-4 col-form-label">
                                                Đơn vị cha:
                                            </label>
                                            <div className="col-sm-8">
                                                <DonViSelectTree
                                                    name="idDVCha"
                                                    value={values.idDVCha}
                                                    onChange={onChange}
                                                    noChoose
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-sm-2 control-label">Email:<span className="text-red"> * </span></label>
                                    <div className="col-sm-4">
                                        <Form.Control
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder="Email"
                                            onChange={handleChange}
                                            value={values.email}
                                            isValid={touched.email && !errors.email}
                                            isInvalid={touched.email && !!errors.email}
                                        />
                                        {touched.email && errors.email ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>                                
                                <div className="form-group row">                                    
                                    <label className="col-sm-2 col-form-label">Số điện thoại:
                                    </label>
                                    <div className="col-sm-4">
                                        <Form.Control
                                            id="dienThoai"
                                            name="dienThoai"
                                            type="text"
                                            placeholder="Số điện thoại"
                                            onChange={handleChange}
                                            value={values.dienThoai}
                                            isValid={touched.dienThoai && !errors.dienThoai}
                                        />
                                    </div>
                                    <label className="col-sm-2 control-label">Thứ tự:<span className="text-red"> * </span></label>
                                    <div className="col-sm-4">
                                        <Form.Control
                                            id="thuTu"
                                            name="thuTu"
                                            type="number"                                            
                                            placeholder="Thứ tự"
                                            onChange={handleChange}
                                            value={values.thuTu}
                                            isValid={touched.thuTu && !errors.thuTu}
                                            isInvalid={touched.thuTu && !!errors.thuTu}
                                        />
                                        {touched.thuTu && errors.thuTu ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.thuTu}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>                                
                                <div className="form-group row">
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <label className="col-sm-4 col-form-label">
                                                Trạng thái:
                                            </label>
                                            <div className="col-sm-8">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    placeholder="Trạng thái"
                                                    filterOption = {function (search, item: any) {
                                                        return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                                                    }}
                                                    options={[
                                                        {
                                                            value: 0,
                                                            label: 'Ngừng hoạt động',
                                                        },
                                                        {
                                                            value: 1,
                                                            label: 'Đang hoạt động',
                                                        }
                                                    ]}
                                                    value={values.trangThai}
                                                    onChange={(newValue: number) => { setFieldValue("trangThai", newValue); }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {menu[Links.DonVi.Xoa] && values.id > 0 &&
                                        <div className="col text-left">
                                            <Button className="btn btn-danger" type="button" onClick={() => setOpenModalXoa(true)} title="Xóa">Xóa <i className="fas fa-trash-alt" /></Button>
                                        </div>
                                    }
                                    {menu[Links.DonVi.Xoa] &&
                                        <div className="col text-right">
                                            <Button className="btn btn-primary" type="submit" title="Lưu">Lưu <i className="fa fa-save" /></Button>
                                        </div>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ChiTietDonVi;
